import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import ComplianceHeader from "components/__new/compliance/ComplianceHeader";
// import { ButtonLoader } from "components/__new/common/form";
import successGif from "assets/images/icons/success-green.gif";
import useLoginInfo from "hooks/useLoginInfo";
import * as complianceActions from "store/entities/compliance/action";


const ApprovalSuccess = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    
    useEffect(() => {
        if (userInfo.employer.isCompliant === false){
            history.push("/compliance");
        }
        dispatch(complianceActions.updateComplianceProgress(100));
        // eslint-disable-next-line
    }, [])
    
    return (
        <div>
            
            <DynamicHeadTag
                headerText="Earnipay Compliance"
                headerDescription="Complete each step to access all Earnipay features"
            />
            
            <ComplianceHeader />
            
            <div className="pt-6 px-6 pb-24 sm:pt-10 sm:px-10">
                <div className="w-full max-w-2xl mx-auto box py-14">
                    <div className="w-full max-w-sm mx-auto text-center flex flex-col items-center">
                        
                        <div className="w-60 h-60 mx-auto flex items-center justify-center">
                            <img src={successGif} alt="Success" className="object-contain" />
                        </div>
                        
                        <div className="text-ep-primary font-bold text-lg">
                            Yipee!, Your business has been verfied 
                        </div>
                        
                        <div className="w-full mt-6">
                            <Link to="/dashboard" className="btn btn-ep-primary btn-block btn-lg">
                                Dismiss
                            </Link>
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
    )
}


export default ApprovalSuccess;